import { useMemo } from 'react';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import {
  normalizeUpscFaqItemsResponse,
  UPSC_FAQ_ITEMS_CMS_API_PATH,
  UPSC_FAQ_SESSION_KEYS
} from '@api/fetchers/upscCurrentAffairs/faqItems';

export interface UpscFaqItem {
  id: number;
  faqQuestion: string;
  faqAnswer: string;
}

export interface UpscFaqSessionData {
  faqHeading: string;
  faqSession: UpscFaqItem[];
}

export type UpscFaqSessionKey = typeof UPSC_FAQ_SESSION_KEYS[number];

export interface UpscFaqItemsData {
  homeFaq?: UpscFaqSessionData;
  todayAnalysisFaq?: UpscFaqSessionData;
  subjectWiseFaq?: UpscFaqSessionData;
  quizFaq?: UpscFaqSessionData;
  detailedArticlePage?: UpscFaqSessionData;
}

export interface UseUpscCurrentAffairsFaqItemsReturn {
  faqItems: UpscFaqItemsData;
  isLoading: boolean;
  isError: boolean;
}

const useUpscCurrentAffairsFaqItems =
  (): UseUpscCurrentAffairsFaqItemsReturn => {
    const { data, isValidating, isError } = useFetch(
      UPSC_FAQ_ITEMS_CMS_API_PATH,
      { hostType: HOST_TYPE.CMS, useCamelCase: true }
    );

    const faqItems = useMemo(() => normalizeUpscFaqItemsResponse(data), [data]);

    return {
      faqItems,
      isLoading: !data && !isError && isValidating,
      isError: Boolean(isError)
    };
  };

export default useUpscCurrentAffairsFaqItems;
